var map = {
	"./adani_data.js": [
		2653,
		653
	],
	"./iimv_data.js": [
		1260,
		260
	],
	"./imi_data.js": [
		9068,
		68
	],
	"./payment_data.js": [
		2369
	],
	"./spjain_data.js": [
		2295,
		295
	],
	"./xlri_data.js": [
		6889,
		889
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7073;
module.exports = webpackAsyncContext;